import { Card, CardBody, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

type Props = {
  message?: string;
};

export default function NoItemsCard({ message }: Props) {
  const { t } = useTranslation();

  return (
    <Card>
      <CardBody>
        <Text>{message ?? t("common.labels.no_items")}</Text>
      </CardBody>
    </Card>
  );
}
